import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { EsignatureComponent } from '../../components/Nav/Esignature';
import { fetchEsignatureDocumentsCount } from '@pec/aion-ui-core/actions/fetchEsignatureDocumentsCount';
import { fetchOrganizationIfNeeded } from '@pec/aion-ui-core/actions/organization';
import { Loading } from '../../components/Loading';
import { Location } from 'history';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';

const { Client } = OrganizationFeature;

type OwnProps = {
  location: Location;
  organizationId: string;
};

const mapStateToProps = (state: CommonRootState) => ({
  ...state.organization,
  ...state.notifications,
  ...state.options
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchOrganizationIfNeeded: () => dispatch(fetchOrganizationIfNeeded(organizationId)),
  fetchEsignatureDocumentsCount: (isClient: boolean) =>
    dispatch(fetchEsignatureDocumentsCount(organizationId, isClient))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class Esignature extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchOrganizationIfNeeded();

    const { organization } = props;

    const isAssigneeOrg = organization === null || !organization.features.includes(Client);

    props.fetchEsignatureDocumentsCount(isAssigneeOrg);
  }

  render() {
    const {
      organization,
      isFetching,
      fetchError,
      navExpanded,
      esignatureDocuments: esignatureDocumentsCount
    } = this.props;

    return organization && !isFetching ? (
      <EsignatureComponent
        navExpanded={navExpanded}
        notificationCount={esignatureDocumentsCount}
        organizationId={organization.id}
      />
    ) : fetchError ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const EsignatureContainer = connect(mapStateToProps, mapDispatchToProps)(Esignature);
